import { render, staticRenderFns } from "./NoFlowBlock.vue?vue&type=template&id=2bae5ef2&scoped=true&"
import script from "./NoFlowBlock.vue?vue&type=script&lang=js&"
export * from "./NoFlowBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bae5ef2",
  null
  
)

export default component.exports